export default __webpack_public_path__ + "static/media/background.46df87eb.png";